import { useCallback, useEffect, useRef } from 'react';

import { maxVideoRecordingDuration } from 'features/signmail/constants';
import { SignMailEventBus } from 'features/signmail/services';
import { ParticipantsStatusEventBus } from 'features/call/call-status/services';

export const useSignMailRecordingTimer = () => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isMountedRef = useRef(true);

  const clearRecordingTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const startRecordingTimer = useCallback(() => {
    if (!isMountedRef.current) {
      console.log('DEBUG: Component unmounted - preventing timer start');
      return;
    }

    console.log('DEBUG: starting SignMail recording timer');
    // Clear any existing timer first
    clearRecordingTimer();

    timerRef.current = setTimeout(() => {
      console.log(
        'DEBUG: SignMail recording timer expired - finishing recording'
      );
      SignMailEventBus.recordingFinished$.next();
      ParticipantsStatusEventBus.deaf.$disconnectSignMail.next();
    }, maxVideoRecordingDuration);

    console.log('DEBUG: timer started successfully');
  }, [clearRecordingTimer]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      console.log('DEBUG: Component unmounting - running cleanup');
      isMountedRef.current = false;
      clearRecordingTimer();
    };
  }, [clearRecordingTimer]);

  return {
    startRecordingTimer,
    clearRecordingTimer,
  };
};
